import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';

import * as styles from './styles.css';
import { CloseButton } from './parts';

export interface IMapModalProps {
  children: React.ReactNode;
  closeTestId?: string;
  /** Шапка над всем содержимым модалки — как у полноэкранной галереи. */
  header?: React.ReactNode;
  testId: string;
  onClose(): void;
}

/** Полноэкранная модалка с картой: белая подложка, крестик закрытия поверх содержимого. */
export function MapModal({ children, closeTestId, header, testId, onClose }: IMapModalProps): React.JSX.Element {
  return (
    <ModalFullscreen escape open portal theme="white" onClose={onClose}>
      <div className={styles['container']} data-testid={testId}>
        {header}
        <div className={styles['content']}>{children}</div>
        <CloseButton testId={closeTestId} onClose={onClose} />
      </div>
    </ModalFullscreen>
  );
}
